import * as ActionTypes from './actionTypes.js';
import extend from 'lodash/extend';

export default function commissionSummaryReducer(state = {}, action) {
    switch (action.type) {
        case ActionTypes.COMMISSIONS_SUMMARY_DATA:
        case ActionTypes.YTD_SUMMARY:
        case ActionTypes.COMMISSIONS_FILE_DOWNLOAD_SUCCESS:
            return extend({}, state, action.payload, { showError: false });
        case ActionTypes.COMMISSIONS_PDF_FETCH_FAILED:
        case ActionTypes.COMMISSIONS_XLS_FETCH_FAILED:
            return extend({}, state, action.payload, { showError: true });
        case ActionTypes.RESET_COMMISSIONS_SUMMARY:
            return {};
        default:
            return state;
    }
}
